<template>
  <el-form class="login-form" status-icon :rules="loginRules" ref="loginForm" size="medium" :model="loginForm"
    label-width="0">
    <el-form-item v-if="tenantMode" prop="tenantId">
      <el-input @keyup.enter.native="handleLogin" v-model="loginForm.tenantId" auto-complete="off"
        :placeholder="$t('login.tenantId')">
        <i slot="prefix" class="icon-quanxian" />
      </el-input>
    </el-form-item>
    <el-form-item prop="username">
      <el-input @keyup.enter.native="handleLogin" v-model="loginForm.username" auto-complete="off"
        :placeholder="$t('login.username')">
        <i slot="prefix" class="icon-yonghu" />
      </el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input @keyup.enter.native="handleLogin" :type="passwordType" v-model="loginForm.password" auto-complete="off"
        :placeholder="$t('login.password')">
        <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword" />
        <i slot="prefix" class="icon-mima" />
      </el-input>
    </el-form-item>
    <!-- <el-form-item v-if="this.website.captchaMode" prop="code">
      <el-row :span="24">
        <el-col :span="16">
          <el-input @keyup.enter.native="handleLogin" v-model="loginForm.code"
            auto-complete="off" :placeholder="$t('login.code')">
            <i slot="prefix" class="icon-yanzhengma"/>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <img :src="loginForm.image" class="login-code-img" @click="refreshCode" />
          </div>
        </el-col>
      </el-row>
    </el-form-item> -->
    <el-form-item>
      <el-button type="primary" @click.native.prevent="handleLogin" class="login-submit">{{ $t('login.submit')
        }}</el-button>
    </el-form-item>
    <el-form-item>
      <el-button type="warning" @click.native.prevent="handleLegacyMigration" class="login-submit legacy-migration-submit">
        登录并进入新后台
      </el-button>
    </el-form-item>
    <el-form-item>
      <el-divider>{{ $t('login.otherLogin') }}</el-divider>
    </el-form-item>
    <el-form-item>
      <div class="other-login">
        <img @click="feishuLogin" style="width: 36px;cursor: pointer;border-radius: 18px;"
          src="@/assets/icon/feishu-icon.png">
        <el-popover placement="top" title=" " width="300" trigger="hover" @show="handlePopoverShow">
          <div id="qr_code_container" style="width: 300px;height: 300px;">
          </div>
          <div style="display: flex;justify-content: center;margin-top: 10px;">请使用飞书app扫码登录</div>
          <div slot="reference">
            <img style="margin-left: 10px;width: 36px;cursor: pointer;" src="@/assets/icon/qr-code-icon.png">
          </div>
        </el-popover>

      </div>
    </el-form-item>
  </el-form>
</template>
<script></script>
<script>
import { mapGetters } from "vuex";
import { info } from "@/api/system/tenant";
import { getCaptcha } from "@/api/user";

export default {
  name: "userlogin",
  data () {
        return {
          qrCodeGenerated: false,
              tenantMode: false,
          loginForm: {
            //租户ID
            tenantId: this.website.tenantId,
        //用户名
        username: "",
        //密码
        password: "",
        //账户类型
        type: "account",
        //验证码的值
        code: "",
        //验证码的索引
        key: "",
        //预加载白色背景
        image: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      },
      loginRules: {
        tenantId: [
          { required: false, message: "请输入租户ID", trigger: "blur" }
        ],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 1, message: "密码长度最少为6位", trigger: "blur" }
        ]
      },
      passwordType: "password"
    };
  },
  created () {
    this.getTenant();
    this.refreshCode();
  },
  mounted () {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';
    document.body.appendChild(script);
  },
  computed: {
    ...mapGetters(["tagWel"])
  },
  props: [],
  methods: {
    // 初始化滑动验证码
    initTXcode () {
      return new Promise((resolve, reject) => {
        try {
          const captcha = new TencentCaptcha('2018146048', res => {
            console.log(res);
            // 已经滑动指定位置
            if (res.ticket) {
              resolve(res.ticket + '######' + res.randstr);
            }
            if (res.ret) {
              reject();
            }
            reject();
          });
          captcha.show();
        } catch (err) {
          reject();
          console.log(err);
        }
      });
    },
    refreshCode () {
      getCaptcha().then(res => {
        const data = res.data;
        this.loginForm.key = data.key;
        this.loginForm.image = data.image;
      })
    },
    showPassword () {
      this.passwordType === ""
        ? (this.passwordType = "password")
        : (this.passwordType = "");
    },
    handleLogin () {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {

          // 发起登陆前需要滑动验证
          let ticket = await this.initTXcode()

          if (!ticket) {
            console.log(ticket)
            return
          }
          this.loginForm.ticket = ticket
          const loading = this.$loading({
            lock: true,
            text: '登录中,请稍后。。。',
            spinner: "el-icon-loading"
          });
          this.$store.dispatch("LoginByUsername", this.loginForm).then(() => {
            this.$router.push({ path: this.tagWel.value });
            loading.close();
          }).catch(() => {
            loading.close();
            this.refreshCode();
          });
        }
      });
    },
    handleLegacyMigration () {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return;
        const migrationUrl = process.env.VUE_APP_NEW_CONSOLE_MIGRATION_URL;
        if (!migrationUrl) {
          this.$message.error('新后台迁移地址未配置，请联系管理员');
          return;
        }
        const ticket = await this.initTXcode();
        if (!ticket) return;
        this.loginForm.ticket = ticket;
        const loading = this.$loading({ lock: true, text: '正在验证旧账号…', spinner: 'el-icon-loading' });
        try {
          await this.$store.dispatch('LoginByUsername', this.loginForm);
          const legacyToken = this.$store.state.user.token;
          if (!legacyToken) throw new Error('旧账号登录失败');
          this.submitMigrationForm(migrationUrl, {
            legacy_source: 'saas',
            username: this.loginForm.username,
            raw_password: this.loginForm.password,
            legacy_token: legacyToken
          });
          this.loginForm.password = '';
        } catch (error) {
          this.$message.error(error && error.message ? error.message : '旧账号登录失败');
          this.refreshCode();
        } finally {
          loading.close();
        }
      });
    },
    submitMigrationForm (url, fields) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      form.target = '_self';
      Object.keys(fields).forEach(key => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = fields[key];
        form.appendChild(input);
      });
      document.body.appendChild(form);
      form.submit();
      form.remove();
    },
    getTenant () {
      let domain = window.location.href.split("/#/")[0];
      // 临时指定域名，方便测试
      //domain = "https://lebox.vip";
      info(domain).then(res => {
        const data = res.data
        if (data.success && data.data.tenantId) {
          this.tenantMode = false
          this.loginForm.tenantId = data.data.tenantId
          if (data.data.backgroundUrl) {
            this.$parent.$refs.login.style.backgroundImage = `url(${data.data.backgroundUrl})`
          }
        }
      })
    },
    /** 飞书登录 */
    feishuLogin () {
      /** appId 是在飞书开发者控制台提前建立好的 写死为cli_a604920b78ba100c 这个代表sass后台的应用id  */
      const redirectUri = encodeURIComponent(process.env.VUE_APP_FEISHU_REDIRECT_URI)
      const url = `https://open.feishu.cn/open-apis/authen/v1/authorize?app_id=cli_a604920b78ba100c&redirect_uri=${redirectUri}`
      window.location.href = url
    },
    /** 飞书二维码登录 */
    /** 初始化qrcode对象 */
    qrCodeInit() {
      // 飞书应用的app_id
      const app_id = 'cli_a604920b78ba100c';
      // 重定向URI
      const redirect_uri = process.env.VUE_APP_FEISHU_REDIRECT_URI;
      // 可以是一个随机字符串，用于CSRF防护
      const state = 'test';
      const qrCodeUrl = 'https://passport.feishu.cn/suite/passport/oauth/authorize?' +
      'app_id=' + encodeURIComponent(app_id) +
      '&redirect_uri=' + encodeURIComponent(redirect_uri) +
      '&response_type=code' +
      '&state=' + encodeURIComponent(state);
      // eslint-disable-next-line no-undef
      const QRLoginObj = QRLogin({
      id: 'qr_code_container',
      goto: qrCodeUrl,
      width: '300',
      height: '300',
      style: 'width:300px;height:300px;border:1px solid #000'
      });
      window.addEventListener('message', function (event) {
      if (QRLoginObj.matchOrigin(event.origin) && event.data && event.data.tmp_code) {
      const tmp_code = event.data.tmp_code;
      window.location.href = qrCodeUrl + '&tmp_code=' + tmp_code;
      }
      }, false);
    },
    handlePopoverShow() {
      if (!this.qrCodeGenerated) {
      this.qrCodeInit();
      this.qrCodeGenerated = true;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.legacy-migration-submit {
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(230, 162, 60, 0.28);
}

.other-login {
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    width: 36px;
    height: 36px;
  }
}
</style>
